import NextImage from '../../NextImage';

const CLASS_NAMES = {
  topRight: 'sm:w-36 md:w-350 sm:h-[144px] md:h-[350px] absolute right-0 top-0 z-0',
  bottomRight: 'sm:w-36 md:w-350 sm:h-[144px] md:h-[350px] absolute right-0 bottom-0',
  bottomLeft: 'sm:w-36 md:w-350 sm:h-[144px] md:h-[350px] absolute left-0 bottom-0',
};

interface IImage {
  src?: string;
  type: keyof typeof CLASS_NAMES;
}

export const Image = ({ src, type }: IImage) => {
  if (!src) {
    return null;
  }

  return (
    <div className={CLASS_NAMES[type]}>
      <NextImage alt="Side image" src={src} />
    </div>
  );
};
